import { render } from "./TODO_REMINDER.vue?vue&type=template&id=284a628b&ts=true"
import script from "./TODO_REMINDER.vue?vue&type=script&lang=ts"
export * from "./TODO_REMINDER.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__